<dx-popup
    minWidth="150px"
    minHeight="150px"
    width="20%"
    height="15%"
    title="Reverse Cash Receipt"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [visible]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'">
        <dx-box *ngIf="!!editorResult" width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form width="100%" height="100%" [labelLocation]="defaultLabelLocation">
                        <dxi-item [isRequired]="true">
                            <dxo-label text="Reverse Date"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box [(value)]="editorResult.reverseDate" [min]="editorResult.minReverseDate">
                                    <dx-validator>
                                        <dxi-validation-rule
                                            type="required"
                                            message="Reverse date is required"
                                        ></dxi-validation-rule>
                                    </dx-validator>
                                </dx-date-box>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onHidden()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconSave"
                                    (onClick)="onSaveClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: 'body' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
